import SiafLiteImpressoraApi from "../../external/siaf-lite-impressora-api";
import SiafLiteApiRepository from "../../external/siafLiteApi";

class EtiquetasService {
  constructor() {
    this.urlBase = "/estoque/etiquetas";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  buscarModeloBase(id, body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/print/teste-impressao/${id}`).patch(
      body
    );
  }

  buscarModeloCustomizado(id, body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/print/${id}`).patch(
      body
    );
  }

  imprimir(body) {
    return new SiafLiteImpressoraApi("/impressora/etiqueta").post(body);
  }
}

export default EtiquetasService;
